import cx from 'classnames';

import {renderUtils} from 'utils';

type Props = {
    children: React.ReactElement | React.ReactElement[]| ((props: {onClose: () => void}) => React.ReactElement);
    className?: any;
    transparent?: boolean;
    hideOnClick?: boolean;
    onClose: () => void;
};

export const DropdownChildren = ({children, className, transparent, hideOnClick, onClose}: Props) => (
    <div className={cx('tw-text-default', {'tw-bg-light tw-shadow-md': !transparent}, className)}>
        {renderUtils.renderFunctionOrElementChildren(children, {hideOnClick, onClose})}
    </div>
);
